/**
 * Splash strings before the app (and its i18n) loads: same resolution as `resolveEffectiveLocale`
 * (explicit selection in localStorage, else the first device language: exact tag, `pt-*` → pt-BR
 * except pt-PT, then the base language, else English), limited to the locales that translate them.
 */
import { SPLASH_LABELS } from './labels';

const SELECTION_KEY = 'teacheck.language.selection';

export function splashLocale(): string {
  const known = new Map(Object.keys(SPLASH_LABELS).map((code) => [code.toLowerCase(), code]));
  try {
    const selection = localStorage.getItem(SELECTION_KEY);
    if (selection && SPLASH_LABELS[selection]) return selection;
  } catch { /* private mode */ }
  const tag = ((navigator.languages && navigator.languages[0]) || navigator.language || 'en').replace(/_/g, '-').toLowerCase();
  const exact = known.get(tag);
  if (exact) return exact;
  const [language = 'en', ...rest] = tag.split('-');
  if (language === 'pt') return rest.includes('pt') ? 'en' : known.get('pt-br') ?? 'en';
  return known.get(language) ?? 'en';
}

/** `[label, accessibility label]` for the splash. */
export function splashStrings(): readonly [string, string] {
  return SPLASH_LABELS[splashLocale()] ?? SPLASH_LABELS.en ?? ['Opening case', 'Detectea is loading'];
}
